"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const ListIcon_vue_1 = __importDefault(require("./ListIcon.vue"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let TrialsPanel = class TrialsPanel extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.resetInput = false;
        this.selectedStep = 2;
        this.allTrials = [];
        this.allLocations = [];
        this.trialsType = '';
        this.trialSelect = this.trial;
        this.metric = true;
        this.disabledBtn = true;
        this.timesResponse = null;
        this.locationResponse = null;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    dwGlobalReport(id) {
        window.open(`/trials/summary/report/${id}`);
        this.$emit('closeTrials', true);
    }
    created() {
        this.callAllTrials(`/data/results/trials/${this.projectId}`);
        this.callAllLocations('/data/results/trials/locations/list');
    }
    reset() {
        this.allTrials = [];
        this.allLocations = [];
        this.trialsType = '';
        this.trialSelect = null;
        this.metric = true;
        this.disabledBtn = true;
        this.selectedStep = 2;
        this.callAllTrials(`/data/results/trials/${this.projectId}`);
        this.callAllLocations('/data/results/trials/locations/list');
        this.resetInput = true;
    }
    mounted() {
        this.resetInput = true;
    }
    trialsTypeF(value) {
        this.trialsType = value;
        this.timesResponse = null;
        this.locationResponse = null;
        this.trialsTypeMixpanel(value);
    }
    trialsTypeMixpanel(type) {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('trialsTypeMixpanel', {
            origin: originModule,
            trialsType: type,
        });
    }
    metricSteps(step, trial) {
        this.selectedStep = step;
        if (step === 2) {
            this.trialSelect = this.trial;
        }
    }
    get filterLocations() {
        var _a;
        const response = [];
        for (const location of this.allLocations) {
            for (const id of (_a = this.trialSelect) === null || _a === void 0 ? void 0 : _a.reports2[0].location_ids) {
                if (location.id === id) {
                    response.push(location);
                }
            }
        }
        if (this.exceedLimit)
            return [];
        return response;
    }
    get exceedLimit() {
        const maxItems = this.trial.reports2[0].max_item_compare || 0;
        return this.locationResponse && this.locationResponse.length >= maxItems;
    }
    get isVersionPreMAA() {
        return this.trial.reports2[0].version <= "3.5";
    }
    closeModalAction() {
        this.metric = false;
        this.$emit('closeTrials', true);
    }
    async callAllTrials(url) {
        try {
            const request = await fetch(url);
            const response = await request.json();
            this.allTrials = response;
            return response;
        }
        catch (error) {
            console.error(error);
        }
    }
    get getAllTimes() {
        const STAGES = this.trialSelect.stages;
        const set = new Set(STAGES);
        const stagesUnicos = [...set];
        const stagesUnicosFilterTime0 = stagesUnicos.filter((item) => {
            return item.time !== 0;
        });
        const times = [];
        for (const time of stagesUnicosFilterTime0) {
            times.push(time.time);
        }
        const setTimes = new Set(times);
        const timesUnicos = [...setTimes];
        const newTimesUnicos = [];
        for (const timet of timesUnicos) {
            newTimesUnicos.push({ time: timet });
        }
        return newTimesUnicos;
    }
    getAllTimesForTrial(trial) {
        const STAGES = trial.stages;
        const set = new Set(STAGES);
        const stagesUnicos = [...set];
        const stagesUnicosFilterTime0 = stagesUnicos.filter((item) => {
            return item.time !== 0;
        });
        const times = [];
        for (const time of stagesUnicosFilterTime0) {
            times.push(time.time);
        }
        const setTimes = new Set(times);
        const timesUnicos = [...setTimes];
        return timesUnicos.length;
    }
    async callAllLocations(url) {
        try {
            const request = await fetch(url);
            const response = await request.json();
            this.allLocations = response;
            return response;
        }
        catch (error) {
            console.error(error);
        }
    }
    modelEmitTimes(val) {
        if (this.trialsType === 'times') {
            const ids = [];
            for (const time of val) {
                if (time.time !== 0) {
                    ids.push(time.time);
                }
            }
            this.timesResponse = ids;
            if (this.timesResponse.length < 1 ||
                this.locationResponse === '' ||
                !this.timesResponse ||
                !this.locationResponse) {
                this.disabledBtn = true;
            }
            else {
                this.disabledBtn = false;
            }
        }
        else {
            this.timesResponse = val.time;
            if (this.timesResponse === '' ||
                !this.locationResponse ||
                (this.locationResponse && this.locationResponse.length < 1) ||
                !this.timesResponse ||
                !this.locationResponse) {
                this.disabledBtn = true;
            }
            else {
                this.disabledBtn = false;
            }
        }
    }
    modelEmitLocations(val) {
        if (this.trialsType === 'location') {
            const ids = [];
            for (const location of val) {
                ids.push(location.id);
            }
            this.locationResponse = ids;
            if (this.timesResponse === '' ||
                this.locationResponse.length < 1 ||
                !this.timesResponse ||
                !this.locationResponse) {
                this.disabledBtn = true;
            }
            else {
                this.disabledBtn = false;
            }
        }
        else {
            this.locationResponse = val.id;
            if (this.timesResponse.length < 1 ||
                this.locationResponse === '' ||
                !this.timesResponse ||
                !this.locationResponse) {
                this.disabledBtn = true;
            }
            else {
                this.disabledBtn = false;
            }
        }
    }
    async downloadTrials() {
        var _a, _b;
        let url = '';
        const urlTimes = `/data/results/trials/${(_a = this.trialSelect) === null || _a === void 0 ? void 0 : _a.id}/report/location/${this.locationResponse}?times=${this.timesResponse.toString()}`;
        const urlLocations = `/data/results/trials/${(_b = this.trialSelect) === null || _b === void 0 ? void 0 : _b.id}/report/time/${this.timesResponse}?locations=${this.locationResponse.toString()}`;
        if (this.trialsType === 'location') {
            url = urlLocations;
        }
        else {
            url = urlTimes;
        }
        window.open(url, '_blank');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TrialsPanel.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], TrialsPanel.prototype, "projectId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], TrialsPanel.prototype, "trial", void 0);
TrialsPanel = __decorate([
    (0, vue_property_decorator_1.Options)({
        emits: ['closeTrials'],
        components: {
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            WidgetCard: bmk_ui_framework_1.WidgetCard,
            PlusIcon: bmk_ui_framework_1.PlusIcon,
            YieldLogo: bmk_ui_framework_1.YieldLogo,
            FarmLogo: bmk_ui_framework_1.FarmLogo,
            TrialsLogo: bmk_ui_framework_1.TrialsLogo,
            RateLogo: bmk_ui_framework_1.RateLogo,
            BizLogo: bmk_ui_framework_1.BizLogo,
            DiseasesLogo: bmk_ui_framework_1.DiseasesLogo,
            LicenseLogo: bmk_ui_framework_1.LicenseLogo,
            ManagementLogo: bmk_ui_framework_1.ManagementLogo,
            OpsLogo: bmk_ui_framework_1.OpsLogo,
            ProposalsLogo: bmk_ui_framework_1.ProposalsLogo,
            ResultsLogo: bmk_ui_framework_1.ResultsLogo,
            TestLogo: bmk_ui_framework_1.TestLogo,
            Button: bmk_ui_framework_1.Button,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            Modal: bmk_ui_framework_1.Modal,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            PinIcon: bmk_ui_framework_1.PinIcon,
            ListIcon: ListIcon_vue_1.default,
            RefreshCcw: lucide_vue_next_1.RefreshCcw,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            ViewZero: bmk_ui_framework_1.ViewZero,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            FileText: lucide_vue_next_1.FileText,
        },
    })
], TrialsPanel);
exports.default = TrialsPanel;
